import React from 'react';
import { Link } from 'react-router-dom';
import { Stack, Button } from '@mui/material';

import Logo from '../assets/images/Logo.png';

const Navbar = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      sx={{
        gap: { xs: '20px', sm: '122px' },
        mt: { xs: '20px', sm: '32px' },
        justifyContent: 'none',
        px: { xs: '10px', sm: '20px' },
        py: { xs: '10px', sm: '20px' },
        backgroundColor: '#fcc757',
        borderRadius: '20px',
      }}
    >
      <Link to="/">
        <Button
          sx={{
            ml: '10px',
            color: '#fff',
            background: 'radial-gradient(circle, #fcc757, #fca44f)',
            fontSize: { xs: '16px', sm: '14px' },
            borderRadius: '20px',
            textTransform: 'capitalize',
          }}
        >
          <img
            src={Logo}
            alt="logo"
            style={{ width: '100%', height: 'auto', margin: '0 2px', maxWidth: '100px' }}
          />
        </Button>
      </Link>
      <Stack direction="row" gap="20px" alignItems="flex-end" mb={{ xs: '10px', sm: '20px' }}>
        <Link
          to="/"
          style={{
            textDecoration: 'none',
            background: 'linear-gradient(to right, #3A1212, #FF2625)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            borderBottom: '3px solid #FF2625',
            fontSize: { xs: '20px', sm: '35px' },
          }}
        >
          Home
        </Link>
        <Link
          to="/Account"
          style={{
            textDecoration: 'none',
            background: 'linear-gradient(to right, #3A1212, #FF2625)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            borderBottom: '3px solid #FF2625',
            fontSize: { xs: '20px', sm: '35px' },
          }}
        >
          Account
        </Link>
        <Link
          to="/trainers"
          style={{
            textDecoration: 'none',
            background: 'linear-gradient(to right, #3A1212, #FF2625)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            borderBottom: '3px solid #FF2625',
            fontSize: { xs: '20px', sm: '35px' },
          }}
        >
          Trainers
        </Link>
      </Stack>
    </Stack>
  );
}

export default Navbar;
